import {defaultTo} from 'ramda';

import {Nullish, parseDate} from 'shared/web';

export function getCompletionAt(date?: Date | Nullish, time?: string | Nullish) {
  if (!date) {
    return;
  }

  const minutes = defaultTo(0, parseInt(defaultTo('', time).substring(3)));
  const hours = defaultTo(0, parseInt(defaultTo('', time).substring(0, 2)));

  const completionAt = date && parseDate(date);

  completionAt.setHours(hours); // eslint-disable-line eag/no-native-date-math -- Pre-existing native Date math, migrate to date-fns when possible
  completionAt.setMinutes(minutes); // eslint-disable-line eag/no-native-date-math -- Pre-existing native Date math, migrate to date-fns when possible

  return completionAt.toISOString();
}
